import React from 'react';

interface SunsetStripeProps {
  className?: string;
  height?: string;
  variant?: 'stepped' | 'smooth';
}

export const SunsetStripe: React.FC<SunsetStripeProps> = ({
  className = '',
  height = 'h-1.5',
  variant = 'stepped',
}) => {
  if (variant === 'smooth') {
    return (
      <div
        className={`w-full ${height} bg-gradient-to-r from-sunset-gold via-sunset-flame to-sunset-crimson ${className}`}
        aria-hidden="true"
      />
    );
  }

  return (
    <div className={`w-full ${height} grid grid-cols-4 ${className}`} aria-hidden="true">
      <div className="bg-sunset-gold h-full" />
      <div className="bg-sunset-orange h-full" />
      <div className="bg-sunset-flame h-full" />
      <div className="bg-sunset-crimson h-full" />
    </div>
  );
};
